import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { InventoryControlPage } from '@/features/inventory'

export const Route = createFileRoute('/_authenticated/inventory/control')({
  component: () => (
    <RequirePermission permission='inventory_ledger.read'>
      <InventoryControlPage />
    </RequirePermission>
  ),
})
